import { useEffect, useState } from "react";
import { Gamepad2, Gift, MessageCircleHeart, ShieldCheck, Star } from "lucide-react";
import { api } from "@/lib/api";
import { PhoneMockup } from "@/components/landing/PhoneMockup";

const PERKS = [
  [Gamepad2, "Über 20 Spiele", "Herz-Läufer, Zuckerherz Saga, Zwei Herzen, Glücksrad, Rubbellose & mehr."],
  [MessageCircleHeart, "Mit Freunden", "Fordere Freunde heraus, kletter in den Bestenlisten und teile deine Erfolge."],
  [Gift, "Echte Prämien", "Jede Runde bringt Punkte – löse sie gegen Gutscheine & Geschenke ein."],
];


export function useLandingStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/public/stats").then(({ data }) => setS(data)).catch(() => {}); }, []);
  return s;
}


const fmt = (n) => (n >= 10000 ? `${(n / 1000).toLocaleString("de-DE", { maximumFractionDigits: 1 })}k` : Number(n || 0).toLocaleString("de-DE"));

export const StatRow = ({ stats }) => (
  <div className="grid grid-cols-3 gap-3 max-w-lg" data-testid="hero-stats">
    {[["Beiträge veröffentlicht", stats?.posts, "posts"], ["Punkte verteilt", stats?.points_awarded, "points"], ["Likes vergeben", stats?.likes, "likes"]].map(([l, v, id], i) => (
      <div key={id} className="shine glow-pulse rounded-2xl bg-white/85 backdrop-blur border border-rose-100 px-3 py-3" style={{ "--shine-delay": `${i * 0.6}s`, animationDelay: `${i * 0.4}s` }}>
        <p className="font-display text-xl sm:text-2xl font-extrabold text-slate-900 tabular-nums" data-testid={`hero-stat-${id}`}>{stats ? fmt(v) : "…"}</p>
        <p className="text-[11px] font-semibold text-slate-500 leading-tight">{l}</p>
      </div>
    ))}
  </div>
);

export function HeroMessage({ compact = false, as: H = "h1", stats }) {
  return (
    <div className="space-y-6">
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-rose-200 text-[11px] font-extrabold uppercase tracking-wider text-rose-600 shadow-sm">
        <Star className="w-3.5 h-3.5 fill-rose-500 text-rose-500" /> Die Spiele-App mit echten Prämien
      </span>
      <H className="hero-plain font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.03] text-[#1E1B1D]" data-testid="hero-title">
        Spielen. <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 via-pink-500 to-fuchsia-500">Punkte sammeln.</span> Prämien einlösen.
      </H>
      <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl" data-testid="hero-lead">itzPlay ist deine kostenlose Spiele-Plattform: Spiel jeden Tag neue Runden, sammle bei jedem Spiel Punkte, miss dich mit Freunden – und löse deine Punkte gegen echte Prämien ein.</p>
      {!compact && (
        <ul className="hidden sm:grid sm:grid-cols-3 gap-3">
          {PERKS.map(([Icon, t, d], i) => (
            <li key={t} className="group shine glow-pulse rounded-2xl bg-white/80 border border-rose-100 p-4 hover:-translate-y-0.5 transition-transform duration-300" style={{ "--shine-delay": `${1.8 + i * 0.6}s`, animationDelay: `${i * 0.5}s` }}>
              <span className="w-10 h-10 rounded-xl bg-rose-50 text-rose-500 flex items-center justify-center group-hover:bg-rose-500 group-hover:text-white transition-colors"><Icon className="w-5 h-5" /></span>
              <p className="mt-3 font-bold text-sm text-slate-900">{t}</p>
              <p className="mt-1 text-xs text-slate-500 leading-relaxed">{d}</p>
            </li>
          ))}
        </ul>
      )}
      {stats !== undefined && <StatRow stats={stats} />}
      <p className="flex items-center gap-2 text-xs font-semibold text-slate-500"><ShieldCheck className="w-4 h-4 text-emerald-500" /> Kostenlos · Werbefrei · Made in Germany</p>
    </div>
  );
}

export const HeroPhone = () => <div className="hidden xl:block float-y"><PhoneMockup /></div>;
